import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DictionaryFieldsModule, MasterDetailModule } from '@sdbn/common';

import { ReportingGroupAdministrationComponent } from './component/reporting-group-administration.component';
import { ColorPickerModule } from '@sdbn/tmc-common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule as MatInputModule } from '@angular/material/input';


@NgModule({
  declarations: [
    ReportingGroupAdministrationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    ColorPickerModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    MasterDetailModule,
    DictionaryFieldsModule,
    MatFormFieldModule,
    MatInputModule
  ],

})
export class ReportingGroupAdministrationModule { }

